'use client';

import { useEffect } from 'react';
import { useScrollPreservation } from '../hooks/use-scroll-preservation';
import { useRating } from '@/providers/rating-provider';

interface CityPageWrapperProps {
  children: React.ReactNode;
  citySlug: string;
}

export default function CityPageWrapper({
  children,
  citySlug,
}: CityPageWrapperProps) {
  const { restoreScrollPosition } = useScrollPreservation(citySlug);
  const { checkRatingOnCityPage } = useRating();

  useEffect(() => {
    // Check for pending ratings when visiting city page
    checkRatingOnCityPage();

    // Restore scroll position when component mounts
    const timeoutId = setTimeout(() => {
      restoreScrollPosition();
    }, 100);

    return () => clearTimeout(timeoutId);
  }, [checkRatingOnCityPage, restoreScrollPosition]);

  return <>{children}</>;
}
